<template>
    <v-tab-item
        eager
    >
        <div class="mx-sm-1 mx-md-16">
            <v-row>
                <v-col>
                    <span class="text-body-1 font-weight-medium">{{ $t('chooseTypesOfDrug') }}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    md="4"
                >
                    <v-autocomplete
                        :value="selectedCategories"
                        :items="categories"
                        color="grey"
                        item-color="grey"
                        multiple
                        chips
                        deletable-chips
                        small-chips
                        item-text="localName"
                        item-value="id"
                        :rules="rules"
                        @change="setCategories"
                    >
                        <template v-slot:selection="data">

                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-chip-group>
                        <v-chip
                            v-for="(item, index) in selectedCategories"
                            :key="index"
                            class="ma-2"
                            close
                            @click:close="removeCategory(item)"
                        >{{ getCategoryName(item) }}</v-chip>
                    </v-chip-group>
                </v-col>
            </v-row>
        </div>

    </v-tab-item>
</template>

<script>
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";

export default {
    name: "CategoryTab",
    mixins: [ CalculatorDataProvider ],
    props: ['calculationIdx', 'treatmentIdx', 'categories'],
    data() {
        return {
            rules: [
                value => !!value || this.$t('requiredField'),
                value => (value.length !== undefined && value.length > 0) || this.$t('requiredField'),
            ],
        }
    },
    computed: {
        selectedCategories() {
            return this.getTreatmentCategoryIDs(this.calculationIdx, this.treatmentIdx);
        },
    },
    methods: {
        getCategoryName(id) {
            const category = this.categories.find(item => item.id === id);
            return category ? category.localName : '';
        },
        setCategories(IDs) {
            this.setSelectedCategories(this.calculationIdx, this.treatmentIdx, IDs)
        },
        removeCategory(id) {
            this.deleteCategory(this.calculationIdx, this.treatmentIdx, id)
        }

    }
}
</script>

<style scoped>

</style>
